import {
  Button,
  Stack,
  Typography,
} from "@braintrust/braintrust-ui-components";
import {
  CircleCheckIcon,
  CircleUncheckedIcon,
} from "@braintrust/braintrust-ui-components/Icons";

type CheckboxButtonProps = {
  onClick: () => void;
  isSelected: boolean;
  label: string;
  variant: "green" | "violet";
};

export const CheckboxButton = ({
  onClick,
  isSelected,
  label,
  variant,
}: CheckboxButtonProps) => {
  return (
    <Button
      onClick={onClick}
      variant={isSelected ? `medium-${variant}` : `white-${variant}`}
      shape="squared"
      sx={{ flexGrow: 1, justifyContent: "start !important" }}
    >
      <Checkbox isSelected={isSelected} label={label} />
    </Button>
  );
};

type CheckboxProps = {
  isSelected: boolean;
  label: string;
};

const Checkbox = ({ isSelected, label }: CheckboxProps) => {
  return (
    <Stack direction="row" sx={{ gap: 1, paddingBlock: 1 }}>
      {isSelected ? (
        <CircleCheckIcon sx={{ color: "var(--black)" }} />
      ) : (
        <CircleUncheckedIcon />
      )}
      <Typography component="p" color="primary" variant="label">
        {label}
      </Typography>
    </Stack>
  );
};
